import { uploadGCSFile } from "./signedGCSFile"
import { httpClient as axiosInstance, apiUrls } from "@/src/api"
import { CONFIG } from "@/src/config-global"

import type { WorkspaceInfo } from "../auth/types"
import type { ApiResponse } from "../types/apiResponse"

export const uploadWorkspaceLogo = async (logo: File): Promise<ApiResponse<WorkspaceInfo>> => {
    const resp = await uploadGCSFile(logo, "PUBLIC")
    if (resp.status === "error" || !resp.data) return { status: "error", errorMessage: resp.errorMessage }

    const fileName = resp.data.split("/").pop()
    const newLogoUrl = `https://protocolx.gumlet.io/${fileName}`

    return axiosInstance
        .put(apiUrls.COMPANY_UPDATE_LOGO(), {
            logoUrl: newLogoUrl,
        })
        .then((updateResp): ApiResponse<WorkspaceInfo> => {
            return { status: "success", data: updateResp.data?.data }
        })
        .catch((error): ApiResponse<WorkspaceInfo> => {
            console.log(error)
            return { status: "error", errorMessage: error.message }
        })
}

export type CreateWorkspacePayload = {
    name: string
    logoUrl?: string
    websiteUrl?: string
    aboutWorkspace: string
    config: {
        maxJobLimit: number
        allowGuestUsers: boolean
        preferredLanguages: string[]
    }
    roundTypeCredits: {
        QUICK_SCREENING: number
        DETAILED_ASSESSMENT: number
        TECH_ASSESSMENT: number
        TECHNICAL_INTERVIEW: number
        MANAGERIAL_INTERVIEW: number
        BEHAVIORAL_ASSESSMENT: number
        HUMAN_ROUND: number
    }
    userIds: string[]
}

export const createWorkspace = async (payload: CreateWorkspacePayload): Promise<ApiResponse<WorkspaceInfo>> => {
    return axiosInstance
        .post(apiUrls.WORKSPACE_CREATE, payload, {
            headers: {
                "x-api-key": CONFIG.site.apiKey || "",
                "x-api-secret": CONFIG.site.apiSecret || "",
            },
        })
        .then((response): ApiResponse<WorkspaceInfo> => {
            return { status: "success", data: response.data?.data }
        })
        .catch((error): ApiResponse<WorkspaceInfo> => {
            console.error("Failed to create workspace:", error)
            const errorMessage = error.response?.data?.message || error.message || "Failed to create workspace"
            return { status: "error", errorMessage }
        })
}
